// @ts-ignore
/* eslint-disable */
import type { CustomRequestOptions } from '../customRequestOptions';
import { request } from '../axios/sdpMerchant';

/** 预留信息查询 POST /mch/reserved/query */
export async function mchReservedQuery(options?: CustomRequestOptions) {
  return request<APISdpMerchant.GatewayDataResponseString_>('/mch/reserved/query', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 预留信息设置 POST /mch/reserved/reset */
export async function mchReservedReset(
  body: APISdpMerchant.ResetReservedRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpMerchant.GatewayResponse>('/mch/reserved/reset', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
